$(function() {
    $('.js-show-info__btn').on('click', function openBlock() {
        const $parent = $(this).closest('.js-show-info__block');
        if ($($parent).hasClass('is-open')) {
            $($parent).removeClass('is-open');
        } else {
            $('.js-show-info__block').removeClass('is-open');

            $($parent).addClass('is-open');
        }
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/open-block.js